<script setup>
import { reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useSession } from '../composables/useSession'
import AppIcon from '../components/AppIcon.vue'

const router = useRouter()
const route = useRoute()
const session = useSession()
const form = reactive({ username: '', password: '' })
const error = ref('')
const revealPassword = ref(false)

async function submit() {
  error.value = ''
  if (!form.username.trim() || !form.password) {
    error.value = 'Введите логин и пароль.'
    return
  }

  try {
    await session.login({ username: form.username.trim(), password: form.password })
    const next = typeof route.query.next === 'string' && route.query.next.startsWith('/')
      ? route.query.next
      : '/'
    await router.replace(next)
  } catch (requestError) {
    error.value = requestError.status === 401
      ? 'Неверный логин или пароль.'
      : requestError.message || 'Не удалось войти. Попробуйте ещё раз.'
  }
}
</script>

<template>
  <main class="login-page">
    <section class="login-scene" aria-label="База отдыха Курочкино">
      <div class="login-scene__copy">
        <span class="login-brand">
          <svg viewBox="0 0 48 48" fill="none" aria-hidden="true">
            <path d="M24 3C21 13 14 18 7 24c6 0 11-2 16-7-3 7-8 11-14 15h13v12h4V32h13c-6-4-11-8-14-15 5 5 10 7 16 7C34 18 27 13 24 3Z" fill="currentColor" />
          </svg>
          <span>Курочкино</span>
        </span>
        <div>
          <p class="login-kicker">База отдыха</p>
          <h1>Вся загрузка базы — в одном месте.</h1>
          <p>Брони, объекты и ближайшие заезды для спокойной работы команды.</p>
        </div>
      </div>

      <svg class="login-landscape" viewBox="0 0 920 420" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
        <path d="M0 295C140 246 246 276 368 236c126-42 224-107 340-82 82 18 140 55 212 57v209H0V295Z" fill="#d5d4b9" />
        <path d="M0 336c164-42 270-9 421-55 172-52 330-41 499 12v127H0v-84Z" fill="#7b8f70" />
        <path d="M0 372c179-25 294 11 463-29 168-39 306-29 457 11v66H0v-48Z" fill="#294f40" />
        <g fill="#173f35">
          <path d="M98 271c-4 23-19 39-38 55h29c-10 13-21 24-37 34h92c-16-10-29-21-37-34h28c-18-16-33-32-37-55Z" />
          <path d="M758 216c-6 35-29 59-57 83h43c-14 20-32 36-55 51h139c-24-15-43-31-57-51h44c-29-24-52-48-57-83Z" />
          <path d="M652 278c-4 22-18 37-35 51h26c-8 12-19 22-33 31h84c-14-9-25-19-34-31h27c-18-14-31-29-35-51Z" opacity=".88" />
        </g>
        <path d="M365 319h115v77H365z" fill="#e9e1ce" />
        <path d="m348 323 75-55 75 55" fill="#9d4f37" />
        <path d="M386 345h30v51h-30zM434 338h25v22h-25z" fill="#173f35" />
        <path d="M0 393c160-10 307 18 464-1 168-21 308 3 456 17v11H0v-27Z" fill="#102f29" />
      </svg>
    </section>

    <section class="login-panel">
      <form class="login-form" @submit.prevent="submit">
        <div class="login-form__heading">
          <span class="eyebrow">Панель управления</span>
          <h2>Вход в CRM</h2>
          <p>Используйте свою учётную запись.</p>
        </div>

        <label class="field">
          <span>Логин</span>
          <input v-model="form.username" type="text" name="username" autocomplete="username" required autofocus placeholder="Введите логин" />
        </label>
        <label class="field">
          <span>Пароль</span>
          <span class="password-input">
            <input v-model="form.password" :type="revealPassword ? 'text' : 'password'" name="password" autocomplete="current-password" required placeholder="Введите пароль" />
            <button type="button" @click="revealPassword = !revealPassword">{{ revealPassword ? 'Скрыть' : 'Показать' }}</button>
          </span>
        </label>

        <p v-if="error" class="form-error" role="alert">{{ error }}</p>

        <button class="button button--primary button--large button--full" type="submit" :disabled="session.pending">
          <span v-if="session.pending" class="button-spinner" aria-hidden="true" />
          {{ session.pending ? 'Входим…' : 'Войти' }}
          <AppIcon v-if="!session.pending" name="arrow-right" :size="18" />
        </button>
      </form>
      <p class="login-help">Учётную запись оператора создаёт администратор CRM.</p>
    </section>
  </main>
</template>
